import { BarChart2, ExternalLink } from "lucide-react";
import { getStatConfig, formatPlayerName } from "./gameUtils";

export const StatLeaders = ({ broadcast, boxScoreData }) => {
  const homeTeam = typeof broadcast.home_team === 'object' ? broadcast.home_team : { name: broadcast.home_team };
  const awayTeam = typeof broadcast.away_team === 'object' ? broadcast.away_team : { name: broadcast.away_team };

  const sport = broadcast.sport || 'basketball';
  const statConfig = getStatConfig(sport);
  const leaders = boxScoreData?.data?.stat_leaders || {};

  const displayStats = statConfig.primary.map(statKey => ({
    key: statKey,
    label: statConfig.labels[statKey] || statKey,
    away: leaders[statKey]?.away || null,
    home: leaders[statKey]?.home || null
  }));

  return (
    <div className="bg-zinc-900/50 border border-white/10 p-4">
      <h3 className="text-white font-bold text-sm uppercase tracking-wider mb-4 flex items-center gap-2">
        <BarChart2 className="w-4 h-4 text-orange-500" />
        Stat Leaders
      </h3>

      {/* Team Headers */}
      <div className="flex items-center justify-between mb-4 px-2">
        <div className="flex items-center gap-2">
          {awayTeam?.logo_url ? (
            <img src={awayTeam.logo_url} alt="" className="w-6 h-6 object-contain" />
          ) : (
            <div className="w-6 h-6 rounded-full bg-zinc-700 flex items-center justify-center">
              <span className="text-[10px] text-white">{awayTeam?.name?.charAt(0)}</span>
            </div>
          )}
          <span className="text-zinc-400 text-xs uppercase">{awayTeam?.abbreviation || awayTeam?.name?.substring(0, 3)}</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-zinc-400 text-xs uppercase">{homeTeam?.abbreviation || homeTeam?.name?.substring(0, 3)}</span>
          {homeTeam?.logo_url ? (
            <img src={homeTeam.logo_url} alt="" className="w-6 h-6 object-contain" />
          ) : (
            <div className="w-6 h-6 rounded-full bg-zinc-700 flex items-center justify-center">
              <span className="text-[10px] text-white">{homeTeam?.name?.charAt(0)}</span>
            </div>
          )}
        </div>
      </div>

      {/* Stats */}
      <div className="space-y-4">
        {displayStats.map((stat) => (
          <div key={stat.key}>
            <p className="text-center text-zinc-500 text-xs uppercase mb-2">{stat.label}</p>
            <div className="flex items-center justify-between">
              <div className="text-left flex-1">
                {stat.away ? (
                  <>
                    <p className="text-white font-bold text-sm">{stat.away.value || '-'}</p>
                    <p className="text-zinc-500 text-xs truncate">{formatPlayerName(stat.away.player) || '-'}</p>
                  </>
                ) : (
                  <p className="text-zinc-600">-</p>
                )}
              </div>
              <div className="w-px h-8 bg-zinc-700 mx-4"></div>
              <div className="text-right flex-1">
                {stat.home ? (
                  <>
                    <p className="text-white font-bold text-sm">{stat.home.value || '-'}</p>
                    <p className="text-zinc-500 text-xs truncate">{formatPlayerName(stat.home.player) || '-'}</p>
                  </>
                ) : (
                  <p className="text-zinc-600">-</p>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {broadcast.stats_link && (
        <a
          href={broadcast.stats_link}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-4 flex items-center justify-center gap-2 w-full py-3 bg-green-600 hover:bg-green-700 text-white font-bold uppercase text-xs transition-colors"
        >
          <ExternalLink className="w-4 h-4" />
          Full Stats
        </a>
      )}
    </div>
  );
};
